import RegistrationSuccess from "./registration-success.component";

export default RegistrationSuccess;
